<template>
  <div class="wrapper">
    <video-card
      v-for="(item, index) in videoCards"
      :key="index"
      :ref="item.ref"
      v-bind:class="bindInitialClasses(index)"
      :data="item.data"
    ></video-card>

    <v-btn
      style="position: absolute; top: 85vh; left: 44vw; z-index: 900;"
      class="mt-10"
      @click="toggleAnimation"
      outlined
      fab
      large
      color="white"
      >></v-btn
    >
  </div>
</template>

<script>
import { getVideoCategoryList, getCategory } from './services/api/'
import VideoCard from './components/VideoCard'

export default {
  name: 'VideoCategories',
  components: {
    VideoCard
  },

  data() {
    return {
      headerOptions: {
        color: '#ffffff00'
      },
      videoCards: [], // the list with the card objects that will keep the data for cards inside
      videosList: [], // the list keeping all the videos fetched from server
      videoListLength: null,
      loading: false,
      changeAnimationInterval: null // variable keeping the interval of animating the cards
    }
  },

  created() {
    this.generateVideoCards()
    this.getVideoCategoryList()
    this.autoAnimate()
  },

  beforeDestroy() {
    clearInterval(this.changeAnimationInterval)
  },

  methods: {
    // function to generate initial cards with refs to bind in the dom
    generateVideoCards() {
      for (let i = 0; i < 8; i++) {
        this.videoCards.push({ ref: `card${i}`, data: {} })
      }
    },
    // getVideoCategoryList is the initial call to fetch the objects without the images
    getVideoCategoryList() {
      this.loading = true
      getVideoCategoryList().then((response) => {
        this.videosList = this.normalizeCards(response.data)
        this.videoListLength = this.videosList.length
        this.fetchVideos()
        this.loading = false
      })
    },
    // fetch videos async will iterate on loaded videosList and await for each getCategory then exit the loop and call the initial bind
    async fetchVideos() {
      for (let video of this.videosList) {
        await getCategory({
          responseType: 'arraybuffer',
          params: { cover_name: video.cover_name }
        }).then((response) => {
          video.routeType = 'videos'
          video.routeParam = { category: video.subtitle }
          video.src =
            'data:image/jpeg;base64,' +
            Buffer.from(response.data, 'binary').toString('base64')
        })
      }

      this.bindVideosToCards()
    },
    // the function to animate the whole movement
    toggleAnimation() {
      let elFull = this.$el.querySelector('.full')
      let elGrow = this.$el.querySelector('.grow')
      elGrow.classList.add('full')
      elGrow.classList.remove('grow')

      this.$el.querySelector('.position1').classList.remove('position2')
      this.$el.querySelector('.position1').classList.remove('move2')
      this.$el.querySelector('.position2').classList.remove('position3')
      this.$el.querySelector('.position2').classList.remove('move3')
      this.$el.querySelector('.position3').classList.remove('position4')
      this.$el.querySelector('.position3').classList.remove('move4')
      this.$el.querySelector('.position4').classList.remove('position5')
      this.$el.querySelector('.position4').classList.remove('move5')
      this.$el.querySelector('.position5').classList.remove('position6')
      this.$el.querySelector('.position5').classList.remove('move6')

      let pos1 = this.$el.querySelector('.position1')
      pos1.classList.add('grow')
      this.$el.querySelector('.position2').classList.add('move2')
      this.$el.querySelector('.position3').classList.add('move3')
      this.$el.querySelector('.position4').classList.add('move4')
      this.$el.querySelector('.position5').classList.add('move5')
      this.$el.querySelector('.position6').classList.add('move6')

      pos1.classList.remove('position1')

      this.$el.querySelector('.position2').classList.add('position1')
      this.$el.querySelector('.position3').classList.add('position2')
      this.$el.querySelector('.position4').classList.add('position3')
      this.$el.querySelector('.position5').classList.add('position4')
      this.$el.querySelector('.position6').classList.add('position5')

      elFull.classList.remove('full')
      elFull.classList.add('position6')
    },
    // the automatic animation function
    autoAnimate() {
      this.changeAnimationInterval = setInterval(() => {
        this.toggleAnimation()
      }, 3000)
    },
    // the initial bind of images to cards
    bindVideosToCards() {
      for (let i = 0; i < 8; i++) {
        this.videoCards[i].data = this.videosList[
          this.videoListLength < 8 ? i % this.videoListLength : i
        ]
      }
    },
    // add initial css classes to generated cards in the dom
    bindInitialClasses(index) {
      switch (index) {
        case 0:
          return ['full', 'card']
        case 1:
          return ['grow', 'card']
        case 2:
          return ['position1', 'card']
        case 3:
          return ['position2', 'card']
        case 4:
          return ['position3', 'card']
        case 5:
          return ['position4', 'card']
        case 6:
          return ['position5', 'card']
        case 7:
          return ['position6', 'card']
      }
    },
    normalizeCards(cardsList) {
      let normalizedList = []
      cardsList.forEach((element) => {
        normalizedList.push({
          subtitle: element.name,
          title: element.destination,
          description: element.description,
          cover_name: element.cover_name
        })
      })
      return normalizedList
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100vh;
  width: 100vw;
}
.cover {
  object-fit: cover;
  width: 100vw;
  height: 100vh;
}
.carousel_wrapper {
  position: relative;
  top: 40vh;
  left: 40vw;
  height: 40vh;
  display: flex;
}
.card {
  box-shadow: 15px 15px 8px rgba(0, 0, 0, 0.25),
    10px 10px 10px rgba(0, 0, 0, 0.22);
  border-radius: 15px;
  overflow: hidden;
}
.position1 {
  position: absolute;
  width: 14.8vw;
  height: 22.8vw;
  top: 40vh;
  left: 40vw;
  z-index: 500;
}
.position2 {
  position: absolute;
  width: 14.8vw;
  height: 22.8vw;
  top: 40vh;
  left: 56.5vw;
  z-index: 500;
}
.position3 {
  position: absolute;
  width: 14.8vw;
  height: 22.8vw;
  top: 40vh;
  left: 73vw;
  z-index: 500;
}
.position4 {
  position: absolute;
  width: 14.8vw;
  height: 22.8vw;
  top: 40vh;
  left: 89.5vw;
  z-index: 500;
}
.position5 {
  position: absolute;
  width: 14.8vw;
  height: 22.8vw;
  top: 40vh;
  left: 106vw;
  z-index: 500;
}
.position6 {
  position: absolute;
  width: 14.8vw;
  height: 22.8vw;
  top: 40vh;
  left: 122.5vw;
  z-index: 500;
}
.grow {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  border-radius: 0;
  transition: all 0.5s cubic-bezier(1, 0.44, 0.74, 0.68);
  z-index: 400;
}
.full {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  border-radius: 0;
}
.move2 {
  transition: all 0.5s ease-in-out 0.2s;
  transform: translateX(-15vw);
}
.move3 {
  transition: all 0.5s ease-in-out 0.3s;
  transform: translateX(-15vw);
}
.move4 {
  transition: all 0.5s ease-in-out 0.4s;
  transform: translateX(-15vw);
}
.move5 {
  transition: all 0.5s ease-in-out 0.5s;
  transform: translateX(-15vw);
}
.move6 {
  transition: all 0.5s ease-in-out 0.5s;
  transform: translateX(-15vw);
}
</style>
